<template lang="pug">
.k-pager
  w-btn-icon( :disabled='page === 1' @click.prevent='gotoPage(1)' )
   i-first
  w-btn-icon( :disabled='page === 1' @click.prevent='back' )
   i-back
  transition-group.pages( name='fade-fast' tag='div' mode='out-in' )
    w-btn.pager-page(
      v-for='p in pagesBefore'
      :key='p'
      @click.prevent='gotoPage(p)'
    )
      | {{ p }}
    w-btn.pager-page( :key='page' disabled )
      | {{ page }}
    w-btn.pager-page(
      v-for='p in pagesAfter'
      :key='p'
      @click.prevent='gotoPage(p)'
    )
      | {{ p }}
    template( v-if='showEnd && lastPage && lastPage < pages' )
      .pager-page( key='ellipsis' ) ...
      w-btn.end( key='end' @click.prevent='gotoPage( pages )' )
        | {{ pages }}
  w-btn-icon( :disabled='page === pages' @click.prevent='forward' )
    i-forward
  w-btn-icon( :disabled='page === pages' @click.prevent='gotoPage( pages )' )
    i-last
</template>

<script lang="js">
import range from 'lodash-es/range'
import WBtn from '@/widgets/w-btn'
import WBtnIcon from '@/widgets/w-btn-icon'
import IFirst from 'icons/SkipBackward'
import IBack from 'icons/SkipPrevious'
import IForward from 'icons/SkipNext'
import ILast from 'icons/SkipForward'

export default {
  name: 'PagerBlock',
  mixins: [],
  components: {
    IFirst,
    IBack,
    IForward,
    ILast,
    WBtn,
    WBtnIcon,
  },
  props: {
    value: {
      type: Number,
      default: 1
    },
    pages: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      required: true
    },
    displayRange: {
      type: Number,
      default: 1
    },
    showCount: Boolean,
    showEnd: Boolean,
  },
  data() {
    return {
      page: 1
    }
  },
  created() {
    this.setPage( this.value )
  },
  mounted() {},
  methods: {
    setPage( page ) {
      this.page = page
    },
    gotoPage( page ) {
      page = Math.min( Math.max( 1, page ), this.pages )
      // this.page = page
      this.input( page )
    },
    forward( $event, skip = 1 ) {
      this.gotoPage( this.page +  skip )
    },
    back( $event, skip = 1 ) {
      this.gotoPage( this.page - skip )
    },
    input( page ) {
      this.$emit( 'input', page )
    }
  },
  computed: {
    pagesBefore() {
      const { page, pages, displayRange } = this
      return range(
        Math.max( 1, page - displayRange ),
        page,
        1
      )
    },
    pagesAfter() {
      const { page, pages, displayRange } = this
      return range(
        page + 1,
        Math.min( pages, page + displayRange ) + 1,
        1
      )
    },
    lastPage() {
      const  { pagesAfter } = this
      return pagesAfter.length && pagesAfter[ pagesAfter.length - 1 ]
    }
  },
  watch: {
    value( page ) {
      this.setPage( page )
    }
  }
}
</script>

<style lang="scss">
.k-pager {
  display: flex;
  align-items: flex-start;
  .pages {
    display: flex;
    align-items: center;
  }
  .w-btn {
    padding: var(--s-xs) var(--s-sm);
    &:hover {
      background: var(--c-btn-hover, rgba(0,0,0,0.1));
      &.disabled {
        background: unset;
      }
    }
  }
}
</style>
